import React from 'react';
import {
  Box,
  Stack,
  AppBar,
  ThemeProvider,
  Toolbar,
  Typography,
  Container
} from 'investira.react.components';
import { ErrorBoundary, PessoaImage } from '../../molecules';
import Main from './Main';
import { useDynamicEntidadeTheme } from '../../../themes/runtime';

const EntidadeTemplate = props => {
  const APPBAR_HEIGHT = 64;
  const LOGO_PESSOA_ID = 86934;
  const { children } = props;
  const theme = useDynamicEntidadeTheme(LOGO_PESSOA_ID);

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <Box
          id="entidade"
          sx={{
            flexGrow: 1,
            width: '100vw',
            backgroundColor: 'background.dark'
          }}>
          <Stack id="app-bar-area" sx={{ height: APPBAR_HEIGHT }}>
            <AppBar position="static" elevation={0}>
              <Stack
                id="appbar"
                sx={{
                  height: 'inherit'
                }}
                spacing={3}>
                <Toolbar sx={{ px: 2 }}>
                  <Container maxWidth="xl">
                    <Stack direction="row" gap={2} alignItems="center">
                      <PessoaImage
                        logoPessoaId={LOGO_PESSOA_ID}
                        alt={
                          'Forluz - Fundação Forluminas de Seguridade Social Fundação Forluminas de Seguridade Social Forluz'
                        }
                        hasLogo={true}
                        size={42}
                      />
                      <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 500 }}>
                        Forluz - Fundação Forluminas de Seguridade Social
                      </Typography>
                    </Stack>
                  </Container>
                </Toolbar>
              </Stack>
            </AppBar>
          </Stack>
          <Stack id="content-area" sx={{ height: `calc(100% - ${APPBAR_HEIGHT}px)` }}>
            <Main>{children}</Main>
          </Stack>
        </Box>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default EntidadeTemplate;
